import React from 'react'
import { OutboundLink } from 'gatsby-plugin-google-analytics'
import IconDropbox from '../../images/icons/icon-dropbox.svg'
import IconExcel from '../../images/icons/icon-excel.svg'
import IconGdrive from '../../images/icons/icon-gdrive.svg'
import IconOnedrive from '../../images/icons/icon-onedrive.svg'
import IconPDF from '../../images/icons/icon-pdf.svg'
import IconWord from '../../images/icons/icon-word.svg'

import * as style from './style.module.scss'

const pickIcon = (iconName) => {
    const icon = {
        PDF: <IconPDF />,
        Excel: <IconExcel />,
        Word: <IconWord />,
        Dropbox: <IconDropbox />,
        OneDrive: <IconOnedrive />,
        GoogleDrive: <IconGdrive />,
    }
    return icon[iconName]
}

const IconBubble = React.memo(({ download, file, name }) => (
    <li key={name} className={style.item}>
        <OutboundLink
            className={style.link}
            download={download}
            href={file}
            id={name}
            target="_blank"
        >
            <div className={style.iconBubble}>
                <div className={style.iconBubbleInner}>
                    <div className={style.iconWrap}>{pickIcon(name)}</div>
                </div>
            </div>
            <p className={style.itemName}>{name}</p>
        </OutboundLink>
    </li>
))

const TemplateIconBlock = ({ download, items, title }) => {
    if (items.length > 0) {
        return (
            <div>
                <h2 className={style.blockTitle}>{title}</h2>
                <ul className={style.iconList}>
                    {items.map((item) => {
                        if (item.file) {
                            return (
                                <IconBubble
                                    download={download}
                                    file={item.file}
                                    name={item.name}
                                />
                            )
                        }
                        return null
                    })}
                </ul>
            </div>
        )
    }
    return null
}

export default TemplateIconBlock
